<template>
  <div>
    <div class="toolbar">
      <el-input
        v-model="keyword"
        clearable
        placeholder="企业名称 / 租户编码"
        style="width:240px"
        @keyup.enter.native="load"
      />
      <el-select v-model="status" clearable placeholder="状态" style="width:130px" @change="load">
        <el-option label="全部" value="ALL" />
        <el-option label="试用中" value="TRIAL" />
        <el-option label="已开通" value="ACTIVE" />
        <el-option label="已到期" value="EXPIRED" />
        <el-option label="已禁用" value="DISABLED" />
      </el-select>
      <el-button type="primary" icon="el-icon-search" @click="load">查询</el-button>
    </div>

    <el-table :data="list" border stripe v-loading="loading">
      <el-table-column prop="tenantName" label="企业" min-width="160" show-overflow-tooltip />
      <el-table-column prop="tenantCode" label="租户编码" width="140" />
      <el-table-column prop="planName" label="当前套餐" width="110" />
      <el-table-column prop="status" label="状态" width="90">
        <template slot-scope="{ row }">{{ statusText(row.status) }}</template>
      </el-table-column>
      <el-table-column label="账号" width="100">
        <template slot-scope="{ row }">
          {{ row.userCount || 0 }}{{ accountLimit(row.maxUsers) }}
        </template>
      </el-table-column>
      <el-table-column label="有效期至" width="170">
        <template slot-scope="{ row }">{{ fmtTime(row.usageEndsAt || row.trialEndsAt) }}</template>
      </el-table-column>
      <el-table-column prop="createdAt" label="注册时间" width="170">
        <template slot-scope="{ row }">{{ fmtTime(row.createdAt) }}</template>
      </el-table-column>
      <el-table-column prop="remark" label="备注" min-width="120" show-overflow-tooltip />
      <el-table-column label="操作" width="120" fixed="right">
        <template slot-scope="{ row }">
          <el-button
            v-if="row.status !== 'DISABLED'"
            type="text"
            style="color:#f56c6c"
            @click="onDisable(row)"
          >禁用</el-button>
          <el-button
            v-else
            type="text"
            @click="onEnable(row)"
          >启用</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { listOpsTenants, disableOpsTenant, enableOpsTenant } from '../../api/sys'

export default {
  name: 'OpsTenant',
  data() {
    return {
      loading: false,
      keyword: '',
      status: 'ALL',
      list: []
    }
  },
  created() {
    this.load()
  },
  methods: {
    statusText(s) {
      return ({ TRIAL: '试用中', ACTIVE: '已开通', EXPIRED: '已到期', DISABLED: '已禁用' }[s]) || s || '-'
    },
    accountLimit(max) {
      if (max == null) return ''
      if (Number(max) <= 0) return ' / 不限'
      return ' / ' + max
    },
    fmtTime(v) {
      if (!v) return '-'
      return String(v).replace('T', ' ').slice(0, 19)
    },
    async load() {
      this.loading = true
      try {
        const res = await listOpsTenants({
          keyword: this.keyword || undefined,
          status: this.status || 'ALL'
        })
        this.list = res.data || []
      } finally {
        this.loading = false
      }
    },
    onDisable(row) {
      this.$confirm(`确认禁用租户「${row.tenantName}」？禁用后无法登录。`, '禁用租户', { type: 'warning' })
        .then(async () => {
          await disableOpsTenant(row.id)
          this.$message.success('已禁用')
          this.load()
        })
        .catch(() => {})
    },
    onEnable(row) {
      this.$confirm(`确认启用租户「${row.tenantName}」？`, '启用租户', { type: 'info' })
        .then(async () => {
          await enableOpsTenant(row.id)
          this.$message.success('已启用')
          this.load()
        })
        .catch(() => {})
    }
  }
}
</script>

<style scoped>
.toolbar { display: flex; flex-wrap: wrap; gap: 10px; margin-bottom: 12px; align-items: center; }
</style>
